function Space(){
    return <span> </span>;
}

export default Space;